import { RemoveTeamDialog } from "@components/table/teams/remove-team-dialog";
import { SdbTeam } from "@custom-types/teams-types";
import { DeleteIcon, MenuItem } from "@flat-ui";
import { useState } from "react";

interface Props {
  /** The team to remove */
  team: SdbTeam;

  /** Callback to close the parent 3-dot menu */
  onMenuClose: () => void;
}

/**
 * Menu item that opens a remove-team confirmation dialog.
 */
export function RemoveTeamMenuButton({
  team,
  onMenuClose,
}: Props): JSX.Element {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  function closeDialog(): void {
    setIsDialogOpen(false);
    onMenuClose();
  }

  return (
    <>
      <MenuItem
        label="Remove team"
        Icon={DeleteIcon}
        onClick={() => setIsDialogOpen(true)}
      />
      {isDialogOpen && (
        <RemoveTeamDialog team={team} onClose={closeDialog} />
      )}
    </>
  );
}
